// core
import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'raptorDecimal'
})
export class RaptorDecimalPipe implements PipeTransform {

  transform(question: any, value: string | number, ...args: unknown[]): unknown {
    let formattedValue;
    let decimalPipe = new DecimalPipe('en');

    // The first condition is for vanilla number question types
    // The second is specifically for the increment question that has a decimal format
    // This second condition may be extended to other things in the future
    if (
      (
        !(question.layout) &&
        !(question.settings && question.settings.format && question.settings.format === 'none')
      ) || (
        question.layout &&
        question.settings && question.settings.format && question.settings.format === 'decimal'
      )
    ) {
      value = typeof value === 'string' ? value.replace(/,/g, '') : value;

      if (isNaN(Number(value))) {
        formattedValue = value;
      } else {
        formattedValue = decimalPipe.transform(value, '1.0-0');
      };
    } else {
      formattedValue = value;
    };

    return formattedValue;
  }

}
